import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../app.json";
import auth from "../../../providers/Auth.Provider";
import CorrespondenceList from "./items-list.jsx";
import NewStaffCorrespondence from "./NewItem.jsx";
import { NEW_ATTACHMENT } from "../../../queries/staff.query";
import { useMutation } from "@apollo/react-hooks";
import LoadingSpinner from "../../../partials/loading.jsx";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../util/app";

function StaffCorrespondence({ staff, location }) {
    // local state
    const [newItem, setNewItem] = useState(false);

    // get current staff
    const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
    const { id } = GetToken() && GetAuthenticatedStaff();

    const [sendFunc, { loading }] = useMutation(NEW_ATTACHMENT, {
        onCompleted: data => {
            const { message, doc } = data.NewStaffCorrespondence;
            staff = doc;
            toast.success(message);
        },
        onError: e => toast.error(CleanMessage(e.message))
    });

    return (
        <>
            <Helmet>
                <title>Staff Attachment | {appName}</title>
            </Helmet>
            <div className="row">
                {/* Only allow authenticated user to upload correspondent */}
                <div className="col-md-6">
                    <strong style={{ fontSize: "1.3em" }}>Attachment</strong>
                </div>
                {staff.id === id && (
                    <div className="col-md-6 text-right fade-in">
                        <button type="type" onClick={() => setNewItem(true)} className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle btn-success">
                            <i className="material-icons mx-1">add</i>
                            New
                        </button>
                    </div>
                )}
                <div className="col-md-12">
                    <LoadingSpinner loading={loading} />
                </div>
                {!newItem && (
                    <div className="col-md-12 fade-in m-t-20">
                        <CorrespondenceList items={staff.correspondences} />
                    </div>
                )}
                {newItem && (
                    <div className="col-md-12 fade-in">
                        <NewStaffCorrespondence
                            onCancel={() => {
                                setNewItem(false);
                                document.body.scrollTop = 0;
                                document.documentElement.scrollTop = 0;
                            }}
                            onSubmit={async item => {
                                await sendFunc({
                                    variables: {
                                        id: staff.id,
                                        model: item
                                    }
                                });
                            }}
                        />
                    </div>
                )}
            </div>
        </>
    );
}
export default StaffCorrespondence;
